export default __webpack_public_path__ + "static/media/trash.e75ddf12.svg";